import { createContext, Fragment, useContext, useEffect, useState } from "react";
import { t as ttr, translate, LANGS, RTL_LANGS, setCurrentLang } from "@/lib/i18n";

const KEY = "aurora_lang";
const LangContext = createContext(null);

const initial = () => {
  const saved = localStorage.getItem(KEY);
  if (LANGS.includes(saved)) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return LANGS.includes(nav) ? nav : "it";
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(initial);
  setCurrentLang(lang);
  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = document.documentElement.dataset.seoLang || lang;
    document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: (k) => ttr(lang, k), tr: (it, en) => translate(lang, it, en) }}>
      <Fragment key={lang}>{children}</Fragment>
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
